export const activeTriggerMax = 50;

export enum ReplayType {
  START_REPLAY = "generateMoments",
  STOP_REPLAY = "stopReplay",
  PAUSE_REPLAY = "pauseReplay",
}

export enum ReplayPlaybackSpeed {
  X1 = 1,
  X10 = 10,
  X100 = 100,
  X1000 = 1000,
}

export const ReplayPlaybackSpeedOptions = [
  { value: ReplayPlaybackSpeed.X1, label: "1x" },
  { value: ReplayPlaybackSpeed.X10, label: "10x" },
  { value: ReplayPlaybackSpeed.X100, label: "100x" },
  { value: ReplayPlaybackSpeed.X1000, label: "1000x" },
];

export const APP_DOMAIN = ".cwiggo.live";

// If true, do not show the "No Preview Available" message when there is no data in the broadcast bus preview in the broadcast GFX controller
export const ALWAYS_SHOW_PREVIEW = true;
